import React from 'react'
import './host.css'

const Host = () => {
  return (
    <div className="hosts">
      <div className='host'>
        <h1>Looking to host an amazing venue or online event?</h1>
        <p>There are endless opportunities with Shows for planning and hosting a wide range of events, be it virtual or in-person.<br /> The sky's the limit when creating a remarkable and exceptional experience for yourself and your guests.</p>
      </div>
    </div>
  )
}

export default Host